export const FirstNameOnCardFieldData = {
  formControlName: 'firstNameOnCard',
  id: 'grit-field-first-name-on-card',
  type: 'text',
  label: 'First name (on card)',

  validationList: [
    {
      errorKey: 'cannotContainNumbers',
      message: 'Your first name cannot contain any numbers.',
    },
    {
      errorKey: 'startWithALetter',
      message: 'Your first name must start with a letter.',
    },
    {
      errorKey: 'pattern',
      args: ["^[a-zA-Z '-]+$"],
      message:
        "Your first name can't contain any numbers or special characters other than dash (-), apostrophe(') or a space.",
    },
  ],
  requiredMessage: 'Your first name is required to process your card.',
};
